import React, { Component } from 'react';
import { Field } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDropdown } from '../../../actions/actionCreators';

import {
  renderSearchMultipleDropdown,
  renderSearchDropDown,
} from '../../common/form/FieldHelper';

class ItemLocationDropdown extends Component {
  textFn(doc) {
    const { item = {}, location = {} } = doc;
    return `${item.name || 'No item name'} : ${location.name || 'No location name'}`;
  }

  render() {
    const {
      form,
      multiple,
      name,
      onPostChange,
      searchFn,
      preload = true,
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          component={
            multiple ? renderSearchMultipleDropdown : renderSearchDropDown
          }
          dropdownType="item_location"
          fields={['id']}
          formId={form}
          name={name}
          onPostChange={onPostChange}
          preload={preload}
          searchFn={searchFn}
          textFn={this.textFn}
          textField={this.textFn}
          type="item_location"
          valueField="id"
        />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      searchFn: fetchDropdown,
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(ItemLocationDropdown);
